import {useDark, useToggle} from '@vueuse/core';

export function useDarkMode() {
	const isDarkTheme = useDark({
		selector: 'body',
		storageKey: 'theme',
		attribute: 'class',
		valueDark: 'theme-dark',
		valueLight: '',
		disableTransition: false,
	});

	const toggleDarkMode = useToggle(isDarkTheme);

	return {
		isDarkTheme,
		toggleDarkMode,
	};
}
